import React from 'react'

const ImageLoader = () => {
    return (
        <>
            <div className="flex gap-x-6" >
                <div className="w-[236px] h-[220px] rounded overflow-hidden animate-pulse mb-5">
                    <div className="w-full h-full bg-gray-200"></div>
                </div>
            </div>
        </>
    );
}

export default ImageLoader